// Module
var code = "<div class=\"icon\"> <i class=\"fa fa-slideshare\"/> </div> ";
// Exports
export default code;